import { useContext } from 'react';
import LanguageContext from './LanguageContext';

function useSetLanguage() {
  const context = useContext(LanguageContext);
  return context.setLanguage;
}

export default useSetLanguage;
